(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-faq-answers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fa-item]').forEach(function(item) {
    item.querySelector('.nosu-fa__trigger').addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      item.closest('.nosu-fa__list').querySelectorAll('[data-fa-item]').forEach(function(el) {
        el.classList.remove('is-open');
        el.querySelector('.nosu-fa__trigger').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-floating-atc"]) return;
  try {
    
(function () {
  'use strict';

  var bar = document.getElementById('nosu-fatc');
  if (!bar) return;

  var fatcBtn  = bar.querySelector('[data-fatc-btn]');
  var labelEl  = bar.querySelector('[data-fatc-label]');
  var priceEl  = bar.querySelector('[data-fatc-price]');
  var sepEl    = bar.querySelector('.nosu-fatc__btn-sep');

  var isVisible      = false;
  var hiddenByFooter = false;

  // i18n strings from data attributes
  var labelATC     = bar.dataset.labelAtc     || 'Add to cart';
  var labelSoldOut = bar.dataset.labelSoldOut || 'Sold out';
  var labelOTP     = bar.dataset.labelOtp     || 'One-time purchase';
  var labelSub     = bar.dataset.labelSub     || 'Subscribe & Save';
  var labelSave    = bar.dataset.labelSave    || 'Save __PERCENT__%';
  var labelSaveUpTo = bar.dataset.labelSaveUpTo || '';

  function formatSave(percent) {
    return labelSave.replace('__PERCENT__', String(percent));
  }

  // DOM refs — both layouts (desktop two-drop + mobile merged)
  var allDrops      = bar.querySelectorAll('[data-fatc-drop]');
  // Desktop layout refs
  var dVariantDrop  = bar.querySelector('[data-fatc-drop="variant"]');
  var dPurchaseDrop = bar.querySelector('[data-fatc-drop="purchase"]');
  var dVariantName  = bar.querySelector('[data-fatc-variant-name]');
  var dVariantPpc   = bar.querySelector('[data-fatc-variant-ppc]');
  var dVariantBadge = bar.querySelector('[data-fatc-variant-badge]');
  var dPurchName    = bar.querySelector('[data-fatc-purchase-name]');
  var dPurchSub     = bar.querySelector('[data-fatc-purchase-sub]');
  var dPurchBadge   = bar.querySelector('[data-fatc-purchase-badge]');
  // Mobile layout refs (merged trigger lives inside [data-fatc-drop="combined"])
  var mDrop         = bar.querySelector('[data-fatc-drop="combined"]');
  var mTriggerChip  = mDrop && mDrop.querySelector('[data-fatc-trigger-chip]');
  var mTriggerMain  = mDrop && mDrop.querySelector('[data-fatc-trigger-main]');
  var mTriggerSub   = mDrop && mDrop.querySelector('[data-fatc-trigger-sub]');
  var mTriggerBadge = mDrop && mDrop.querySelector('[data-fatc-trigger-badge]');

  // ── Visibility ────────────────────────────────────────────────────

  function show() { bar.setAttribute('aria-hidden', 'false'); isVisible = true; }
  function hide() { bar.setAttribute('aria-hidden', 'true');  isVisible = false; }

  // ── Dropdown open/close (per drop) ────────────────────────────────

  function openDrop(drop) {
    if (!drop) return;
    // Close any other open drop first
    allDrops.forEach(function (d) { if (d !== drop) closeDrop(d); });
    var p = drop.querySelector('[data-fatc-panel]');
    var t = drop.querySelector('[data-fatc-trigger]');
    drop.dataset.open = '';
    if (p) p.removeAttribute('hidden');
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function closeDrop(drop) {
    if (!drop) return;
    var p = drop.querySelector('[data-fatc-panel]');
    var t = drop.querySelector('[data-fatc-trigger]');
    delete drop.dataset.open;
    if (p) p.setAttribute('hidden', '');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAllDrops() {
    allDrops.forEach(closeDrop);
  }

  // Outside-click close
  document.addEventListener('click', function (e) {
    if (!bar.contains(e.target)) closeAllDrops();
  });

  // ── Mode + trigger helpers ────────────────────────────────────────

  function setMode(mode) {
    bar.dataset.mode = mode;
    // Mobile chip
    if (mTriggerChip) {
      mTriggerChip.dataset.optType = mode;
      mTriggerChip.textContent = mode === 'sub' ? labelSub : labelOTP;
    }
    // Desktop "active drop" highlight
    if (mode === 'otp') {
      if (dVariantDrop)  dVariantDrop.dataset.active  = '';
      if (dPurchaseDrop) delete dPurchaseDrop.dataset.active;
    } else {
      if (dPurchaseDrop) dPurchaseDrop.dataset.active = '';
      if (dVariantDrop)  delete dVariantDrop.dataset.active;
    }
  }

  function setMobileBadge(text) {
    if (!mTriggerBadge) return;
    if (text) {
      var freeUnits = text.match(/\d+\s*\+\s*\d+/);
      var percentage = text.match(/\d+(?:[.,]\d+)?\s*%/);
      mTriggerBadge.textContent = freeUnits ? freeUnits[0].replace(/\s/g, '') : (percentage ? percentage[0].replace(/\s/g, '') : text);
      mTriggerBadge.removeAttribute('hidden');
    } else {
      mTriggerBadge.textContent = '';
      mTriggerBadge.setAttribute('hidden', '');
    }
  }

  function setDesktopPurchaseBadge(text, presentation) {
    if (!dPurchBadge) return;
    dPurchBadge.classList.toggle('nosu-fatc__trigger-badge--callout', presentation === 'callout');
    if (text) {
      dPurchBadge.textContent = text;
      dPurchBadge.style.display = '';
    } else {
      dPurchBadge.style.display = 'none';
    }
  }

  function setDesktopVariantBadge(text) {
    if (!dVariantBadge) return;
    if (text) {
      dVariantBadge.textContent = text;
      dVariantBadge.style.display = '';
    } else {
      dVariantBadge.style.display = 'none';
    }
  }

  function optTitle(opt) {
    var name = opt.querySelector('.nosu-fatc__option-name');
    if (!name) return '';
    return name.childNodes[0]
      ? name.childNodes[0].textContent.trim()
      : name.textContent.trim();
  }

  function optOffer(opt) {
    var offer = opt.dataset.offerText || '';
    if (offer) return offer;
    var pct = parseInt(opt.dataset.savePct || '0', 10);
    return pct > 0 ? formatSave(pct) : '';
  }

  // Reset the (inactive) desktop triggers back to their default placeholder label
  function resetDesktopVariantTrigger() {
    if (dVariantName) dVariantName.textContent = labelOTP;
    if (dVariantPpc)  dVariantPpc.textContent  = '';
    setDesktopVariantBadge('');
  }

  function resetDesktopPurchaseTrigger() {
    if (dPurchName) dPurchName.textContent = labelSub;
    if (dPurchSub)  dPurchSub.textContent  = '';
    setDesktopPurchaseBadge(labelSaveUpTo, 'callout');
  }

  function updateTriggerFromVariantOpt(opt) {
    setMode('otp');
    var title   = optTitle(opt);
    var ppc     = opt.dataset.ppcFmt || '';
    var offer   = optOffer(opt);

    // Desktop variant trigger
    if (dVariantName) dVariantName.textContent = title;
    if (dVariantPpc)  dVariantPpc.textContent  = ppc;
    setDesktopVariantBadge(offer);
    // Selecting a one-time purchase deselects any subscription plan —
    // reset the subscription trigger back to "Subscription"
    resetDesktopPurchaseTrigger();

    // Mobile merged trigger
    if (mTriggerMain) mTriggerMain.textContent = title;
    if (mTriggerSub)  mTriggerSub.textContent  = ppc;
    setMobileBadge(offer);
  }

  function updateTriggerFromPurchaseOpt(opt) {
    setMode('sub');
    var title = optTitle(opt);
    var ppc   = opt.dataset.ppcFmt || '';
    var badge = optOffer(opt);

    // Desktop purchase trigger
    if (dPurchName) dPurchName.textContent = title;
    if (dPurchSub)  dPurchSub.textContent  = ppc;
    setDesktopPurchaseBadge(badge, 'offer');
    // Selecting a subscription deselects any one-time variant —
    // reset the one-time trigger back to "Single Purchase"
    resetDesktopVariantTrigger();

    // Mobile merged trigger
    if (mTriggerMain) mTriggerMain.textContent = title;
    if (mTriggerSub)  mTriggerSub.textContent  = ppc;
    setMobileBadge(badge);
  }

  // The pack currently in the main form, used to carry the selection between
  // the one-time and subscription dropdowns (one selling plan per variant).
  function currentVariantId() {
    var input = document.querySelector('.nosu-atc input[name="id"]');
    return input ? input.value : '';
  }

  function optForCurrentVariant(sel) {
    var vid = currentVariantId();
    return (vid && bar.querySelector(sel + '[data-variant-id="' + vid + '"]:not([disabled])'))
        || bar.querySelector(sel + '.is-selected')
        || bar.querySelector(sel);
  }

  // Selection state is mirrored across BOTH layouts; the two modes are exclusive.
  function markVariantSelected(variantId) {
    bar.querySelectorAll('[data-fatc-variant-opt]').forEach(function (o) {
      var on = o.dataset.variantId === String(variantId);
      o.classList.toggle('is-selected', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    bar.querySelectorAll('[data-fatc-purchase-opt]').forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-selected', 'false');
    });
  }

  function markPlanSelected(planId) {
    bar.querySelectorAll('[data-fatc-purchase-opt]').forEach(function (o) {
      var on = o.dataset.planId === String(planId);
      o.classList.toggle('is-selected', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    bar.querySelectorAll('[data-fatc-variant-opt]').forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-selected', 'false');
    });
  }

  // The main nosu-atc owns the default selection (its "default OTP variant
  // position" setting is not readable from here), so adopt its state on load
  // instead of assuming the first variant.
  function syncFromMainAtc() {
    var atcEl = document.querySelector('[data-nosu-atc]');
    if (!atcEl) return;

    if (atcEl.dataset.activeRow === 'sub') {
      var pOpt = optForCurrentVariant('[data-fatc-purchase-opt]');
      if (!pOpt) return;
      markPlanSelected(pOpt.dataset.planId);
      updateTriggerFromPurchaseOpt(pOpt);
    } else {
      var vOpt = optForCurrentVariant('[data-fatc-variant-opt]');
      if (!vOpt) return;
      markVariantSelected(vOpt.dataset.variantId);
      updateTriggerFromVariantOpt(vOpt);
      if (vOpt.dataset.priceFmt) setPrice(vOpt.dataset.priceFmt);
    }
  }

  // ── Trigger click handlers (one per trigger, three total) ─────────

  bar.querySelectorAll('[data-fatc-trigger]').forEach(function (trig) {
    trig.addEventListener('click', function (e) {
      e.stopPropagation();
      var d = trig.closest('[data-fatc-drop]');
      if (!d) return;

      // Desktop: clicking a trigger also switches the active mode. Applying the
      // option (rather than only relabelling the trigger) keeps the bar and the
      // main form in step, and carries the chosen pack across the two dropdowns.
      var wasOpen  = 'open' in d.dataset;
      var dropType = d.dataset.fatcDrop;
      if (dropType === 'variant') {
        var selV = optForCurrentVariant('[data-fatc-variant-opt]');
        if (selV) selV.click();
      } else if (dropType === 'purchase') {
        var selP = optForCurrentVariant('[data-fatc-purchase-opt]');
        if (selP) selP.click();
      }

      if (wasOpen) closeDrop(d); else openDrop(d);
    });
  });

  // ── Price + availability helpers ──────────────────────────────────

  function setPrice(text) {
    if (priceEl) priceEl.textContent = text;
    if (sepEl)   sepEl.style.display = '';
    if (priceEl) priceEl.style.display = '';
  }

  function setAvailable() {
    if (fatcBtn) fatcBtn.disabled = false;
    if (labelEl) labelEl.textContent = labelATC;
  }

  function setUnavailable() {
    if (fatcBtn) fatcBtn.disabled = true;
    if (labelEl) labelEl.textContent = labelSoldOut;
    if (sepEl)   sepEl.style.display = 'none';
    if (priceEl) priceEl.style.display = 'none';
  }

  // ── OTP option clicks (apply to both layouts) ─────────────────────

  bar.querySelectorAll('[data-fatc-variant-opt]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var variantId = opt.dataset.variantId;

      updateTriggerFromVariantOpt(opt);
      markVariantSelected(variantId);

      if (opt.dataset.priceFmt) setPrice(opt.dataset.priceFmt);

      var tile = document.querySelector('.nosu-atc [data-variant-tile][data-variant-id="' + variantId + '"]');
      if (tile && !tile.disabled) tile.click();

      var otpHd  = document.querySelector('.nosu-atc [data-atc-row="otp"] [data-row-hd]');
      var otpRow = document.querySelector('.nosu-atc [data-atc-row="otp"]');
      if (otpRow && !otpRow.classList.contains('is-active') && otpHd) otpHd.click();

      closeAllDrops();
    });
  });

  // ── Subscription option clicks (apply to both layouts) ────────────

  bar.querySelectorAll('[data-fatc-purchase-opt]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var planId = opt.dataset.planId;

      updateTriggerFromPurchaseOpt(opt);
      markPlanSelected(planId);

      var subHd  = document.querySelector('.nosu-atc [data-atc-row="sub"] [data-row-hd]');
      var subRow = document.querySelector('.nosu-atc [data-atc-row="sub"]');
      if (subRow && !subRow.classList.contains('is-active') && subHd) subHd.click();

      var planTile = document.querySelector('.nosu-atc [data-plan-tile][data-plan-id="' + planId + '"]');
      if (planTile) planTile.click();

      closeAllDrops();
    });
  });

  // ── Sync FROM nosu-atc back to the floating bar ───────────────────

  var nosuAtcEl = document.querySelector('.nosu-atc');
  if (nosuAtcEl) {
    nosuAtcEl.addEventListener('click', function (e) {
      // Variant tile (OTP)
      var vTile = e.target.closest('[data-variant-tile]');
      if (vTile) {
        var vid = vTile.dataset.variantId;
        var vMatch = bar.querySelector('[data-fatc-variant-opt][data-variant-id="' + vid + '"]');
        if (vMatch) {
          markVariantSelected(vid);
          updateTriggerFromVariantOpt(vMatch);
        }
      }

      // Plan tile (Sub)
      var pTile = e.target.closest('[data-plan-tile]');
      if (pTile) {
        var pid = pTile.dataset.planId;
        var pMatch = bar.querySelector('[data-fatc-purchase-opt][data-plan-id="' + pid + '"]');
        if (pMatch) {
          markPlanSelected(pid);
          updateTriggerFromPurchaseOpt(pMatch);
        }
      }

      // Row header (OTP ↔ Sub toggle on the main ATC)
      var rowHd = e.target.closest('[data-row-hd]');
      if (rowHd) {
        var row = rowHd.closest('[data-atc-row]');
        if (row && row.dataset.atcRow === 'otp') {
          var selVTile = nosuAtcEl.querySelector('[data-variant-tile].is-selected')
                      || nosuAtcEl.querySelector('[data-variant-tile]');
          var vMatch2 = selVTile && bar.querySelector('[data-fatc-variant-opt][data-variant-id="' + selVTile.dataset.variantId + '"]');
          if (vMatch2) {
            markVariantSelected(selVTile.dataset.variantId);
            updateTriggerFromVariantOpt(vMatch2);
          }
        } else if (row && row.dataset.atcRow === 'sub') {
          var selPlanTile = nosuAtcEl.querySelector('[data-plan-tile].is-selected')
                         || nosuAtcEl.querySelector('[data-plan-tile]');
          var pMatch2 = selPlanTile && bar.querySelector('[data-fatc-purchase-opt][data-plan-id="' + selPlanTile.dataset.planId + '"]');
          if (pMatch2) {
            markPlanSelected(selPlanTile.dataset.planId);
            updateTriggerFromPurchaseOpt(pMatch2);
          }
        }
      }
    });
  }

  // ── Quantity stepper (mirrors the main nosu-atc qty) ─────────────

  var fatcQtyInput = bar.querySelector('[data-fatc-qty-input]');
  var fatcQtyDec   = bar.querySelector('[data-fatc-qty-dec]');
  var fatcQtyInc   = bar.querySelector('[data-fatc-qty-inc]');

  function reflectFatcQty(v) {
    v = parseInt(v, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (fatcQtyInput) fatcQtyInput.value = String(v);
    if (fatcQtyDec)   fatcQtyDec.disabled = v <= 1;
  }

  function pushQtyToMain(v) {
    v = parseInt(v, 10);
    if (isNaN(v) || v < 1) v = 1;
    var nosuAtc = document.querySelector('[data-nosu-atc]');
    if (nosuAtc) {
      nosuAtc.dispatchEvent(new CustomEvent('nosu-atc:set-qty', { detail: { qty: v } }));
    } else {
      // No main form — keep local state only.
      reflectFatcQty(v);
    }
  }

  if (fatcQtyDec && fatcQtyInput) {
    fatcQtyDec.addEventListener('click', function () {
      pushQtyToMain((parseInt(fatcQtyInput.value, 10) || 1) - 1);
    });
  }
  if (fatcQtyInc && fatcQtyInput) {
    fatcQtyInc.addEventListener('click', function () {
      pushQtyToMain((parseInt(fatcQtyInput.value, 10) || 1) + 1);
    });
  }
  if (fatcQtyInput) {
    fatcQtyInput.addEventListener('change', function () {
      pushQtyToMain(fatcQtyInput.value);
    });
  }

  // Main nosu-atc broadcasts qty changes — mirror them here.
  document.addEventListener('nosu-atc:qty-change', function (e) {
    if (e.detail) reflectFatcQty(e.detail.qty);
  });

  // Initial sync from the main qty input, if rendered.
  (function initFatcQty() {
    var mainQty = document.querySelector('[data-nosu-atc] [data-qty-input]');
    reflectFatcQty(mainQty ? mainQty.value : 1);
  })();

  // ── MutationObserver: price + button state from nosu-atc ─────────

  function observeNosuAtc() {
    var nosuPriceEl = document.querySelector('[data-atc-price]');
    var nosuBtn     = document.querySelector('[data-atc-btn]');

    if (nosuPriceEl) {
      if (priceEl) priceEl.textContent = nosuPriceEl.textContent.trim();

      new MutationObserver(function () {
        var text = nosuPriceEl.textContent.trim();
        if (text) setPrice(text);
      }).observe(nosuPriceEl, { childList: true, characterData: true, subtree: true });
    }

    if (nosuBtn) {
      if (nosuBtn.disabled) setUnavailable();

      new MutationObserver(function () {
        if (nosuBtn.disabled) {
          setUnavailable();
        } else {
          setAvailable();
          var text = nosuPriceEl ? nosuPriceEl.textContent.trim() : '';
          if (text) setPrice(text);
        }
      }).observe(nosuBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  // ── ATC submit ────────────────────────────────────────────────────

  function setLoading(on) {
    if (!fatcBtn) return;
    fatcBtn.disabled = on;
    fatcBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var id = component.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function setCartDrawerBusy(isBusy) {
    var drawer = document.querySelector('cart-drawer-component');
    var items = drawer && drawer.querySelector('cart-items-component');
    if (items) {
      if (isBusy) items.setAttribute('aria-busy', 'true');
      else items.removeAttribute('aria-busy');
    }
    return drawer;
  }

  function openCartDrawer() {
    var drawer = setCartDrawerBusy(true);
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (window.customElements) {
      customElements.whenDefined('cart-drawer-component').then(function () {
        if (typeof drawer.open === 'function') drawer.open();
      });
    }
  }

  function submitViaAjax() {
    var form = document.querySelector('[data-nosu-atc] form');
    if (!form) return false;

    setLoading(true);
    var formData = new FormData(form);
    var sectionIds = cartSectionIds();
    if (sectionIds.length) formData.set('sections', sectionIds.join(','));
    openCartDrawer();

    fetch(form.dataset.ajaxAction || form.action, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('[nosu-fatc] Cart error:', response.message);
          return;
        }

        var atc = document.querySelector('[data-nosu-atc]');
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: form.id,
            data: {
              source: 'nosu-floating-atc',
              itemCount: Number(formData.get('quantity')) || 1,
              productId: atc && atc.dataset.productId || '',
              variantId: String(formData.get('id') || ''),
              sections: response.sections || {}
            }
          }
        }));
      })
      .catch(function (err) {
        console.error('[nosu-fatc]', err);
      })
      .finally(function () {
        setLoading(false);
        setCartDrawerBusy(false);
      });

    return true;
  }

  if (fatcBtn) {
    fatcBtn.addEventListener('click', function () {
      if (submitViaAjax()) return;
      var mainBtn = document.querySelector('product-form-component [ref="addToCartButton"]');
      if (mainBtn) mainBtn.click();
    });
  }

  // ── Mirror the regular ATC's option metadata and styling tokens ──

  function appendOptBadge(opt, text, style) {
    if (!text) return;
    var nameEl = opt.querySelector('.nosu-fatc__option-name');
    if (!nameEl) return;
    var badge = opt.querySelector('.nosu-fatc__option-merch-badge');
    if (!badge) {
      badge = document.createElement('span');
      nameEl.appendChild(document.createTextNode(' '));
      nameEl.appendChild(badge);
    }
    var badgeStyle = style === 'filled' ? 'popular' : 'value';
    badge.className = 'nosu-fatc__option-merch-badge nosu-fatc__option-merch-badge--' + badgeStyle;
    badge.textContent = text;
  }

  function syncAtcTokens() {
    var atc = document.querySelector('[data-nosu-atc]');
    if (!atc) return;
    var styles = getComputedStyle(atc);
    [
      '--nosu-weight-regular',
      '--nosu-weight-emphasis',
      '--nosu-weight-strong',
      '--badge-popular-bg',
      '--badge-popular-text',
      '--badge-value-bg',
      '--badge-value-text',
      '--offer-footer-bg',
      '--offer-footer-text'
    ].forEach(function (property) {
      var value = styles.getPropertyValue(property).trim();
      if (value) bar.style.setProperty(property, value);
    });
  }

  function syncOptionFromTile(opt, tile) {
    var offer = tile.dataset.offer || '';
    var offerEl = opt.querySelector('.nosu-fatc__option-offer');
    opt.dataset.offerText = offer;
    if (offer && !offerEl) {
      offerEl = document.createElement('span');
      offerEl.className = 'nosu-fatc__option-offer';
      opt.insertBefore(offerEl, opt.querySelector('.nosu-fatc__option-price'));
    }
    if (offerEl) {
      offerEl.textContent = offer;
      offerEl.hidden = !offer;
    }
    appendOptBadge(opt, tile.dataset.badge, tile.dataset.badgeStyle);
  }

  function applyTileMetadata() {
    bar.querySelectorAll('[data-fatc-variant-opt]').forEach(function (opt) {
      var tile = document.querySelector('.nosu-atc [data-variant-tile][data-variant-id="' + opt.dataset.variantId + '"]');
      if (!tile) return;
      syncOptionFromTile(opt, tile);
    });
    bar.querySelectorAll('[data-fatc-purchase-opt]').forEach(function (opt) {
      var tile = document.querySelector('.nosu-atc [data-plan-tile][data-plan-id="' + opt.dataset.planId + '"]');
      if (!tile) return;
      syncOptionFromTile(opt, tile);
    });
  }

  // ── IntersectionObserver: show/hide on scroll ─────────────────────

  function setup() {
    var target = document.querySelector('.nosu-atc') || document.querySelector('.buy-buttons-block');
    if (!target) return;

    syncAtcTokens();
    applyTileMetadata();
    syncFromMainAtc();

    var footer = document.querySelector('footer');

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (!entry.isIntersecting) {
        var rect = entry.target.getBoundingClientRect();
        if ((rect.bottom < 0 || rect.top < 0) && !hiddenByFooter) show();
      } else {
        hiddenByFooter = false;
        hide();
      }
    }).observe(target);

    if (footer) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting && isVisible) {
          hiddenByFooter = true;
          hide();
        } else if (!entry.isIntersecting && hiddenByFooter) {
          var rect = target.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top < 0) {
            hiddenByFooter = false;
            show();
          }
        }
      }, { rootMargin: '200px 0px 0px 0px' }).observe(footer);
    }

    observeNosuAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-health-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-nosu-benefits]');
    sections.forEach((root) => {
      const tabs = root.querySelectorAll('[data-nosu-benefit-tab]');
      const panels = root.querySelectorAll('[data-nosu-benefit-panel]');

      const activate = (index) => {
        tabs.forEach((tab) => {
          const isActive = Number(tab.dataset.index) === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const isActive = Number(panel.dataset.index) === index;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(Number(tab.dataset.index)));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          const current = Number(tab.dataset.index);
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          const next = (current + direction + tabs.length) % tabs.length;
          activate(next);
          tabs[next].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-lifestyle-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var AUTO_INTERVAL = 6400;   // total time between advances (pause + travel)
    var SMOOTH_SCROLL_MS = 4800; // estimated smooth-scroll duration
    var RESUME_DELAY = 1700;    // delay before auto resumes after interaction

    document.querySelectorAll('[data-lc-track]').forEach(function(track) {
      var section = track.closest('.nosu-lc-section');
      var dots = section.querySelectorAll('[data-lc-dot]');
      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-lc-slide]'));
      var ORIGINAL_COUNT = originals.length;

      if (ORIGINAL_COUNT < 2) return;

      // Clone the whole set once so we can scroll past the end seamlessly
      originals.forEach(function(slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-lc-clone', '');
        track.appendChild(clone);
      });

      var allSlides = track.querySelectorAll('[data-lc-slide]');
      var current = 0;
      var autoTimer = null;
      var resumeTimer = null;

      function scrollToIndex(index, smooth) {
        var slide = allSlides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft - (track.offsetWidth - slide.offsetWidth) / 2,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }

      function updateDots() {
        var logical = ((current % ORIGINAL_COUNT) + ORIGINAL_COUNT) % ORIGINAL_COUNT;
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === logical); });
      }

      function advance() {
        current++;
        scrollToIndex(current, true);
        updateDots();

        // Once we've scrolled into the cloned set, silently jump back to the
        // matching original position after the smooth scroll settles.
        if (current >= ORIGINAL_COUNT) {
          setTimeout(function() {
            current = current - ORIGINAL_COUNT;
            scrollToIndex(current, false);
          }, SMOOTH_SCROLL_MS);
        }
      }

      function goTo(index) {
        current = Math.max(0, Math.min(index, ORIGINAL_COUNT - 1));
        scrollToIndex(current, true);
        updateDots();
      }

      function startAuto() {
        if (prefersReduced) return;
        stopAuto();
        autoTimer = setInterval(advance, AUTO_INTERVAL);
      }

      function stopAuto() {
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      }

      function pauseThenResume() {
        stopAuto();
        resumeTimer = setTimeout(startAuto, RESUME_DELAY);
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.lcDot, 10));
          pauseThenResume();
        });
      });

      // Pause on user interaction
      track.addEventListener('pointerdown', stopAuto);
      track.addEventListener('pointerup', pauseThenResume);
      track.addEventListener('mouseenter', stopAuto);
      track.addEventListener('mouseleave', startAuto);
      track.addEventListener('focusin', stopAuto);
      track.addEventListener('focusout', startAuto);

      // Only run when the section is on-screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) startAuto();
            else stopAuto();
          });
        }, { threshold: 0.15 }).observe(section);
      } else {
        startAuto();
      }

      // Keep dots in sync when the user drags/swipes
      var ticking = false;
      track.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() {
          var center = track.scrollLeft + track.offsetWidth / 2;
          var closest = current;
          var minDist = Infinity;
          allSlides.forEach(function(slide, i) {
            var dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
            if (dist < minDist) { minDist = dist; closest = i; }
          });
          if (closest !== current) {
            current = closest;
            updateDots();
          }
          ticking = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-problem-solution"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nosu-ps__toggle').forEach(function (toggle) {
    var blockId = toggle.dataset.toggle;
    var card = toggle.closest('.nosu-ps__card');
    toggle.addEventListener('click', function () {
      var isLong = toggle.getAttribute('aria-pressed') === 'true';
      var newVersion = isLong ? 'short' : 'long';
      toggle.setAttribute('aria-pressed', String(!isLong));
      var label = toggle.parentElement.querySelector('.nosu-ps__toggle-text');
      if (label) {
        label.textContent = newVersion === 'long' ? toggle.dataset.longLabel : toggle.dataset.shortLabel;
      }
      var content = document.querySelector('.nosu-ps__content[data-block="' + blockId + '"]');
      content.querySelectorAll('.nosu-ps__version').forEach(function (v) {
        v.classList.remove('nosu-ps__version--active');
      });
      content.querySelector('.nosu-ps__version[data-version="' + newVersion + '"]').classList.add('nosu-ps__version--active');
      if (card) {
        card.classList.toggle('is-long', newVersion === 'long');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-product-info"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-item]').forEach(function(item) {
    item.querySelector('.nosu-pi__faq-trigger').addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      item.closest('.nosu-pi__faq').querySelectorAll('[data-faq-item]').forEach(function(el) {
        el.classList.remove('is-open');
        el.querySelector('.nosu-pi__faq-trigger').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-team-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-tc-section]').forEach(function(section) {
      var track = section.querySelector('[data-tc-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-tc-slide]'));
      var dots = section.querySelectorAll('[data-tc-dot]');
      var prevBtn = section.querySelector('[data-tc-prev]');
      var nextBtn = section.querySelector('[data-tc-next]');

      function visibleCount() {
        if (!slides.length) return 1;
        var trackWidth = track.offsetWidth;
        var slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
        return Math.max(1, Math.round(trackWidth / slideWidth));
      }

      function pageCount() {
        return Math.max(1, slides.length - visibleCount() + 1);
      }

      function currentIndex() {
        if (!slides.length) return 0;
        var center = track.scrollLeft;
        var closest = 0;
        var minDist = Infinity;
        slides.forEach(function(slide, i) {
          var dist = Math.abs(slide.offsetLeft - center);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        return closest;
      }

      function scrollToIndex(index, smooth) {
        var idx = Math.max(0, Math.min(index, pageCount() - 1));
        var slide = slides[idx];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      function updateDots() {
        var idx = currentIndex();
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
        if (prevBtn) prevBtn.toggleAttribute('disabled', idx <= 0);
        if (nextBtn) nextBtn.toggleAttribute('disabled', idx >= pageCount() - 1);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollToIndex(currentIndex() - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollToIndex(currentIndex() + 1, true); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          scrollToIndex(parseInt(dot.dataset.tcDot, 10), true);
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() { updateDots(); ticking = false; });
      });

      window.addEventListener('resize', updateDots);
      updateDots();

      // Modal open/close
      var modals = section.querySelectorAll('[data-tc-modal]');
      var lastFocused = null;

      function openModal(id) {
        var modal = section.querySelector('[data-tc-modal="' + id + '"]');
        if (!modal) return;
        lastFocused = document.activeElement;
        modal.hidden = false;
        document.documentElement.classList.add('nosu-tc-modal-open');
        // Focus close button on next frame for transition
        requestAnimationFrame(function() {
          modal.classList.add('is-open');
          var closeBtn = modal.querySelector('[data-tc-close].nosu-tc__close');
          if (closeBtn) closeBtn.focus();
        });
      }

      function closeModal(modal) {
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('nosu-tc-modal-open');
        setTimeout(function() {
          modal.hidden = true;
          if (lastFocused && lastFocused.focus) lastFocused.focus();
        }, 200);
      }

      section.querySelectorAll('[data-tc-open]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          openModal(btn.getAttribute('data-tc-open'));
        });
        if (btn.tagName !== 'BUTTON') {
          btn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openModal(btn.getAttribute('data-tc-open'));
            }
          });
        }
      });

      modals.forEach(function(modal) {
        modal.querySelectorAll('[data-tc-close]').forEach(function(el) {
          el.addEventListener('click', function() { closeModal(modal); });
        });
      });

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        modals.forEach(function(modal) {
          if (!modal.hidden) closeModal(modal);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-testimonial-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nosu-th__word-wrap').forEach(function (wrap) {
    var video   = wrap.querySelector('.nosu-th__word-video');
    var canvas  = wrap.querySelector('.nosu-th__word-canvas');
    var sizer   = wrap.querySelector('.nosu-th__word-sizer');
    var maskImg = wrap.querySelector('.nosu-th__mask-img');

    // CSS-masked image wraps render the video directly via -webkit-mask-image
    // and have no canvas — nothing to drive from JS.
    if (!canvas || !video) return;

    var ctx     = canvas.getContext('2d');
    var dpr     = window.devicePixelRatio || 1;
    var raf     = null;

    var imgEl      = null;
    var maskReady  = !maskImg;

    if (maskImg) {
      imgEl = new Image();
      imgEl.crossOrigin = 'anonymous';
      imgEl.onload = function () { maskReady = true; };
      imgEl.src = maskImg.src;
      if (imgEl.complete) maskReady = true;
    }

    function setSize() {
      var r = sizer.getBoundingClientRect();
      canvas.width  = Math.round(r.width  * dpr);
      canvas.height = Math.round(r.height * dpr);
    }

    function draw() {
      if (video.readyState < 2 || !maskReady) {
        raf = requestAnimationFrame(draw);
        return;
      }

      setSize();
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (imgEl) {
        ctx.drawImage(imgEl, 0, 0, canvas.width, canvas.height);
      } else {
        var s = getComputedStyle(sizer);
        ctx.font         = s.fontWeight + ' ' + (parseFloat(s.fontSize) * dpr) + 'px ' + s.fontFamily;
        ctx.textAlign    = 'left';
        ctx.textBaseline = 'top';
        ctx.fillStyle    = 'black';
        ctx.fillText(sizer.textContent.trim(), 0, 0);
      }

      ctx.globalCompositeOperation = 'source-in';
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';

      raf = requestAnimationFrame(draw);
    }

    function start() {
      if (!raf) draw();
    }

    video.addEventListener('loadeddata', start);
    video.addEventListener('play', start);
    if (video.readyState >= 2) start();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setSize, 100);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosu-video-word"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nosu-vw__word-wrap').forEach(function (wrap) {
    var video  = wrap.querySelector('.nosu-vw__video');
    var canvas = wrap.querySelector('.nosu-vw__canvas');
    var sizer  = wrap.querySelector('.nosu-vw__sizer');
    var ctx    = canvas.getContext('2d');
    var dpr    = window.devicePixelRatio || 1;
    var raf    = null;

    function setSize() {
      var r = sizer.getBoundingClientRect();
      canvas.width  = Math.round(r.width  * dpr);
      canvas.height = Math.round(r.height * dpr);
    }

    function draw() {
      if (video.readyState < 2) {
        raf = requestAnimationFrame(draw);
        return;
      }

      setSize();
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 1. Draw text as the mask shape
      var s = getComputedStyle(sizer);
      ctx.font          = s.fontWeight + ' ' + (parseFloat(s.fontSize) * dpr) + 'px ' + s.fontFamily;
      ctx.textAlign     = 'left';
      ctx.textBaseline  = 'top';
      ctx.fillStyle     = 'black';
      ctx.fillText(sizer.textContent.trim(), 0, 0);

      // 2. Composite video frame clipped to text pixels
      ctx.globalCompositeOperation = 'source-in';
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';

      raf = requestAnimationFrame(draw);
    }

    function start() {
      if (!raf) draw();
    }

    video.addEventListener('loadeddata', start);
    video.addEventListener('play', start);
    if (video.readyState >= 2) start();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setSize, 100);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
